/* global document */

import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import Paper from 'material-ui/Paper'

import TimeAllocationTables from './TimeAllocationTables.js'

class TimeAllocationReport extends React.Component {

  static propTypes = {
    teamId: PropTypes.string.isRequired,
    teamMembers: PropTypes.array.isRequired,
    printReport: PropTypes.bool.isRequired,
    onPrintCompleted: PropTypes.func.isRequired,
    exportReport: PropTypes.bool.isRequired,
    onExportCompleted: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = this.getStateFromProps(props)
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.getStateFromProps(nextProps))
    if (nextProps.printReport) {
      this.printReport()
      this.props.onPrintCompleted()
    }
    if (nextProps.exportReport) {
      this.exportReportCsv()
      this.props.onExportCompleted()
    }
  }

  getStateFromProps = props => ({
    filters: {
      startDateStr: props.startDateStr,
      endDateStr: props.endDateStr,
      settings: props.settings,
      selectedWorkers: props.selectedWorkers
    }
  })

  printReport = () => {
    var content = ReactDOM.findDOMNode(this.reportCard)
    var pri = document.getElementById('iframeToPrint').contentWindow
    pri.document.open()
    pri.document.write(content.innerHTML)
    pri.document.close()
    pri.focus()
    pri.print()
  }

  exportReportCsv = () => {
    if (this.tables) {
      this.tables.exportCsv()
    }
  }

  render() {
    return (
      <div style={styles.container}>
        <Paper style={styles.paper} ref={paper => this.reportCard = paper}>
          <TimeAllocationTables
            ref={tables => this.tables = tables}
            teamId={this.props.teamId}
            teamMembers={this.props.teamMembers}
            filters={this.state.filters} />
        </Paper>
      </div>
    )
  }

}

const styles = {
  container: {
    paddingLeft: 24,
    paddingRight: 24,
    overflow: 'auto',
    flexGrow: 1,
    alignItems: 'stretch'
  },
  paper: {
    boxShadow: 'none',
    padding: 0 
  }
}

export default connect(state => ({
  teamId: state.firebase.team.metadata.value.id,
  teamMembers: state.firebase.team.members.value
}))(TimeAllocationReport)



// WEBPACK FOOTER //
// ./src/reports/timeAllocation/TimeAllocationReport.js